import { __decorate } from "tslib";
import { Orientation } from '@getgo/chameleon-core';
import { attr } from '@microsoft/fast-element';
import { RadioGroup } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/ChameleonElement';
export class RadioGroupComponent extends ChameleonElementMixin(RadioGroup) {
    constructor() {
        super(...arguments);
        this.orientation = Orientation.vertical;
    }
    connectedCallback() {
        super.connectedCallback();
    }
}
__decorate([
    attr
], RadioGroupComponent.prototype, "orientation", void 0);
